export default __webpack_public_path__ + "static/media/86.a6aab6ae.jpg";